import { ServiceDetailPage } from '../../components/ServiceDetailPage';
import { SERVICE_MEGKESETT } from '../../data/content';
import { Helmet } from 'react-helmet-async';

export default function DelayedSpeechPage() {
  return (
    <>
      <Helmet>
        <title>Megkésett Beszédfejlődés Terápia | Mosolytorna</title>
        <meta name="description" content="Játékos, beszédindító logopédiai foglalkozások megkésett beszédfejlődésű gyermekek számára Dunakeszin. Személyre szabott segítség a kommunikáció elindításához." />
      </Helmet>
      
      <ServiceDetailPage service={SERVICE_MEGKESETT} />
    </>
  );
}
